import {MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType} from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { openapi_website_cms_createCmsTranslation, ParamsType, decodeResponse200, Response200Type } from 'src/api_openapi/generated/openapi_website_cms_createCmsTranslation';

export type CmsTranslationFormModelType = Response200Type;

const decode = (status: number, data: ResponseType): CmsTranslationFormModelType => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface CmsTranslationTypeSubmitType {
    data: ParamsType['body'],
}

export const createCmsTranslation = {
    browser: {
        params: (params: CmsTranslationTypeSubmitType): ParamsFetchType<CmsTranslationTypeSubmitType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/create-cms-translation',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/create-cms-translation',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<CmsTranslationTypeSubmitType>): Promise<GenerateUrlApiType> => {

        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                }
            };
        }

        const response = await openapi_website_cms_createCmsTranslation(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            body: params.req.body.data
        });

        return {
            passToBackend: false,
            status: response.status,
            responseBody: response.body
        };
    }
};
